// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2p2vo","title":"Info_title__19Wvx","selects":"Info_selects__3GCcw","requiredAsterisk":"Info_requiredAsterisk__2zRsI"};